import { render, staticRenderFns } from "./RisksAnalysisBlurb.vue?vue&type=template&id=3cbab3c6&scoped=true&"
import script from "./RisksAnalysisBlurb.vue?vue&type=script&lang=ts&"
export * from "./RisksAnalysisBlurb.vue?vue&type=script&lang=ts&"
import style0 from "./RisksAnalysisBlurb.vue?vue&type=style&index=0&id=3cbab3c6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbab3c6",
  null
  
)

export default component.exports